/**
 * HeroImageUnavailable.jsx
 * Created by Destin Frasier on 9/14/17.
 */

import React from 'react';
import * as Icons from './icons/Icons';

const HeroImageUnavailable = () => (
    <div className="rec-hero-image-unavailable-wrap">
        <figure>
            <Icons.IconPhotoUnavailable />
            <figcaption>Photo Unavailable</figcaption>
        </figure>
    </div>
);

export default HeroImageUnavailable;
